// Pure helpers for the AD audit page: what to fix first, how much risk each weakness carries, and plain text pieces.
export const SEVERITIES = ['critical', 'high', 'medium', 'low', 'info'];
const WEIGHT = { critical: 8, high: 5, medium: 3, low: 1, info: 0.5 };
const RANK = Object.fromEntries(SEVERITIES.map((s, i) => [s, i]));

export const affectedOf = (f) => (f.raw_data?.affected_count ?? (f.raw_data?.affected || []).length) || 0;
export const titleOf = (f) => String(f.title || '').replace('[AD] ', '');
// The explanation without the appended Affected / Remediation blocks.
export const explainOf = (f) => String(f.description || '').split('\n\n**Affected')[0].split('\n\n**Remediation')[0];

// Worst first; among equals, the one touching more accounts first.
export const byPriority = (a, b) => (RANK[a.severity] ?? 9) - (RANK[b.severity] ?? 9) || affectedOf(b) - affectedOf(a);

// Each weakness's share of the audit's total risk weight, in whole percent (same weights as the risk score elsewhere).
export function riskShare(f, all) {
  const total = all.reduce((n, x) => n + (WEIGHT[x.severity] || 0), 0);
  return total ? Math.round(((WEIGHT[f.severity] || 0) / total) * 100) : 0;
}

export const topFixes = (findings, n = 5) => [...findings].filter((f) => f.severity !== 'info').sort(byPriority).slice(0, n);

export function severityCounts(findings) {
  const c = Object.fromEntries(SEVERITIES.map((s) => [s, 0]));
  findings.forEach((f) => { if (c[f.severity] !== undefined) c[f.severity] += 1; });
  return c;
}

export const domainOf = (audit) => (audit?.domains || []).join(', ') || 'Unnamed domain';

export const HOW_TO = [
  'Run SharpHound (or BloodHound.py) with a normal domain user, from a machine that can reach the domain controller.',
  'It creates a few .json files, usually inside a .zip. Keep them together.',
  'Drop them here. Nothing is run against your domain from this platform.'
];
